import React from "react";
import { IconT } from "types/utils";

const RefreshArrowsIcon = ({ height = "18", width = "18", fill = "currentColor" }: IconT) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M4 12a8 8 0 0 1 13.7-5.6M20 12a8 8 0 0 1-13.7 5.6 M17 4v4h-4 M7 20v-4h4"
        stroke={fill}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default RefreshArrowsIcon;
